import script from "./pickBelongCust.vue?vue&type=script&setup=true&lang=js"
export * from "./pickBelongCust.vue?vue&type=script&setup=true&lang=js"

import "./pickBelongCust.vue?vue&type=style&index=0&id=413fe7dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-413fe7dc"]])

export default __exports__